
























































import { createComponent, inject } from "@vue/composition-api";
import {
  BaseActionButton,
  BaseActionButtonGroup
} from "@web-components";
// eslint-disable-next-line
import {
  getIndexInCategoryMap,
  ActivityCategory,
  getActivityCategoryMap
} from "@dcc/types/activityCategory";
import { getActions } from "@dcc/store/score/actions";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

export default createComponent({
  components: {
    BaseActionButton,
    BaseActionButtonGroup
  },
  setup(props: {}, context) {
    const dictionary = useDictionary();
    const activityCategoryMap = getActivityCategoryMap();
    const { trackShowMeHow } = getActions(context.root.$store);

    const handleSelected = (value: number) => {
      // Do GTM update here
      trackShowMeHow();

      context.root.$router.push({
        name: "actionplan",
        params: { tab: activityCategoryMap[value] }
      });
    };

    const activityValues = {
      active: getIndexInCategoryMap(ActivityCategory.ActiveDays),
      easytips: getIndexInCategoryMap(ActivityCategory.EasyTips),
      health: getIndexInCategoryMap(ActivityCategory.Health)
    };

    const actionPlanRef = inject("actionPlanRef");
    return {
      activityValues,
      handleSelected,
      actionPlanRef,
      ...dictionary
    };
  }
});
